import styled from 'styled-components'

import { _S_Medium, desktopMediaQuery, mainColors } from '@avantstay/backoffice-core'

export const Container = styled.div`
  position: relative;
  padding-bottom: 18px;

  &:not(:first-of-type) {
    padding-top: 18px;
  }

  &:not(:last-of-type):after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 24px;
    height: 1px;
    width: calc(100% - 48px);
    background-color: ${mainColors.neutralMedium};
    ${desktopMediaQuery`
      width: calc(100% - 32px);
      left: 16px;
    `}
  }
`

export const Title = styled.h3`
  ${_S_Medium};
  color: ${mainColors.neutralExtremelyDark};
  margin: 0 24px 8px;

  ${desktopMediaQuery`
    margin: 0 16px;
  `}
`
